// extracted by mini-css-extract-plugin
export default {"ratingBox":"FeedbackRating_ratingBox__rik53","ratingTitle":"FeedbackRating_ratingTitle__8Bjxp","starsBox":"FeedbackRating_starsBox__QNCLg"};